export default {
	"delivery.ParameterError": "參數錯誤！",
	"delivery.ShipmentStatus": "發貨狀態",
	"delivery.Shipped": "已發貨",
	"delivery.ShippingTime": "發貨時間",
	"delivery.LogisticsTracking": "物流追蹤",
	"delivery.ThereIsNoLogisticsInformation": "暫無物流資訊",
	"delivery.ShippingAddress": "收貨位址"
}